var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg007AAlarmanlage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.6669999999999,
    height: 451.6669999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 429.613485,
    height: 429.613485,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    ry: 213.823302,
    rx: 213.74094,
    id: "svg_5",
    cy: 225.79493,
    cx: 224.459066,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#777f8e",
    id: "svg_1",
    d: "m222.873568,157.724213c-0.30284,-8.053511 -6.692142,-14.366307 -14.390771,-14.366307c-0.190016,0 -0.380033,0.003084 -0.573021,0.009244c-7.951001,0.323499 -14.144342,7.27404 -13.835566,15.527806l1.386527,36.798437l-46.067107,-12.868981c-7.790673,12.548566 -21.364967,20.882441 -36.791928,20.882441c-18.826468,0 -34.912543,-12.406842 -41.070268,-29.75239l-24.939654,-7.970325l18.758184,-14.871573c6.323982,-5.012648 7.532372,-14.397107 2.701798,-20.959459c-4.830574,-6.562345 -13.87417,-7.819358 -20.198152,-2.80671l-40.993069,32.50056c-9.292996,7.366471 -6.677298,22.598509 4.506946,26.17237l66.452303,21.233655l0,91.518554l-42.928864,25.756441c-4.818695,2.892979 -8.081634,7.933351 -8.829819,13.66077l-11.843373,90.255373c-1.469656,11.217611 6.929662,21.215176 17.870451,21.215176c8.868422,0 16.596747,-6.799574 17.825918,-16.171721l10.649827,-81.182078c55.149291,-33.098264 51.126286,-30.648937 51.933856,-31.17885l11.133776,0l-21.00275,51.67617c-3.230279,7.942594 -0.801633,17.148362 5.872693,22.278086l66.202903,50.90286c7.956938,6.121777 19.24807,4.4396 25.194991,-3.888107c5.923168,-8.293825 4.242709,-20.001298 -3.746889,-26.144638l-54.828642,-42.159231l17.852635,-43.92767c1.160886,-2.859089 1.582479,-5.847573 1.35981,-8.737469l0.092037,0l0,-104.196516l46.251179,12.921352c9.346436,2.615699 18.5266,-4.926378 18.146568,-15.022533l-2.152529,-57.104738l0,0.000001zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#777f8e",
    id: "svg_2",
    d: "m144.988869,159.781702c0,18.56867 -14.503595,33.622018 -32.397798,33.622018c-17.897175,0 -32.40077,-15.053348 -32.40077,-33.622018c0,-18.568669 14.503595,-33.622009 32.40077,-33.622009c17.894203,0 32.397798,15.05334 32.397798,33.622009zm0,0"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ff0033",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 258.690275,
    y: 81.452434,
    width: 112.798208,
    height: 96.156534,
    id: "svg_4",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ff0033",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 314.099926,
    cy: 86.408951,
    id: "svg_6",
    rx: 56.399098,
    ry: 41.634806,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_7",
    d: "m379.631304,171.879801l0,-68.637433c0,-37.846559 -29.120297,-68.637419 -64.913486,-68.637419s-64.913485,30.79086 -64.913485,68.637419l0,68.637433c-7.170918,0 -12.982708,6.145189 -12.982708,13.727487l0,13.727473c0,7.582297 5.81179,13.727499 12.982708,13.727499l129.826971,0c7.170918,0 12.982707,-6.145202 12.982707,-13.727499l0,-13.727473c0,-7.581754 -5.811789,-13.727487 -12.982707,-13.727487zm-116.844277,-68.637433c0,-30.328621 23.252216,-54.909945 51.930791,-54.909945c28.678575,0 51.930791,24.581324 51.930791,54.909945l0,68.637433l-103.861582,0l0,-68.637433zm116.844277,96.092405l-129.826971,0l0,-13.727486l129.826971,0l0,13.727486z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0033",
    id: "svg_8",
    d: "m250.487946,35.328325l-9.174603,-9.700946c-18.807162,19.881801 -30.457108,47.336773 -30.457108,77.614989c0,20.645926 5.517632,39.905704 14.925534,56.424267l11.117441,-7.051429c-8.234878,-14.454616 -13.06028,-31.307256 -13.06028,-49.372839c0,-26.494043 10.191419,-50.517148 26.649015,-67.914043l0.000001,0.000001z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0033",
    id: "svg_9",
    d: "m388.126354,25.622551l-9.174603,9.700946c16.453535,17.401723 26.644954,41.424828 26.644954,67.918871c0,18.065582 -4.825401,34.918222 -13.056231,49.37337l11.117453,7.051428c9.40384,-16.518563 14.921484,-35.783157 14.921484,-56.424798c0,-30.278216 -11.649945,-57.733188 -30.453058,-77.619817l0,0l0.000001,0z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0033",
    id: "svg_10",
    d: "m406.475066,6.21693l-9.178664,9.705231c21.161801,22.370979 34.265706,53.257807 34.265706,87.320751c0,23.226788 -6.205837,44.897988 -16.790787,63.47567l11.117442,7.055712c11.762022,-20.645925 18.65604,-44.724249 18.65604,-70.531926c0,-37.850857 -14.557865,-72.169579 -38.069736,-97.025439l0,0l-0.000001,0.000001z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0033",
    id: "svg_11",
    d: "m232.134667,15.922161l-9.174097,-9.705231c-23.51187,24.85586 -38.069736,59.174569 -38.069736,97.025439c0,25.807676 6.894018,49.88547 18.651978,70.531926l11.117441,-7.055712c-10.580887,-18.58251 -16.786724,-40.25371 -16.786724,-63.476214c0,-34.0624 13.103905,-64.949241 34.261138,-87.320221l0,0.000013z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#193351",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 245.827323,
    y: 182.565528,
    width: 138.524115,
    height: 18.834793,
    id: "svg_12",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.8054,94.671754l0,67.246456l38.172348,0l0,-100.869683c-21.082468,0 -38.172348,15.053224 -38.172348,33.623227z",
    id: "svg_16",
    fill: "#e3e8ee",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg007AAlarmanlage);
export default __webpack_public_path__ + "static/media/007a-Alarmanlage.b60a8eda4eb994c214760e08b0e23800.svg";
export { ForwardRef as ReactComponent };